import { get } from '@/helpers/httpHandler';
import { cloneDeep } from 'lodash';

export default {
  namespaced: true,

  state: {
    notesFilter: {}
  },

  mutations: {
    setNotesFilter: (state, filter) => {
      state.notesFilter = cloneDeep(filter);
    }
  },

  actions: {
    retrieveUsers: () => get('/statistics/users'),
    retrieveUsersStatistics: () => get('/statistics/users-aggregate'),
    retrieveHabitation: () => get('/habitation-statistic'),
    retrievePersons: () => get('/notes-dashboard'),
    retrieveTaskReportsStatistics: () =>
      get('/statistics/tasks-notes-aggregate'),
    retrieveTaskReports: () => get('/statistics/tasks-notes'),
    retrieveMapBuildingComplexes: () => get('/dashboard/map-building-complexes'),
    setNotesFilter: ({ commit }, data) => commit('setNotesFilter', data)
  }
};
